import type { ModuleRoute } from '../types';
import { AgreementPage } from './AgreementPage';
import { SharedReceptionPage } from './SharedReceptionPage';

/** Pages of this area (shared reception, tenant side: the Shared reception page (invitations, sharing statement, site picker, display name, accept, decline, pause, resume, leave), the data-sharing agreement page, plus `SharedLinkBadge` and `BuildingTotalsBanner` in ./parts for the devices and evacuation pages). Owned by shared reception task W-SR2; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/shared-reception', element: <SharedReceptionPage />, permission: 'shared_reception.view' },
  { path: '/manage/shared-reception/agreement/:version', element: <AgreementPage />, permission: 'shared_reception.view' },
];

export { BuildingTotalsBanner, SharedLinkBadge, isSharedLink } from './parts';
